// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomHeader_nav__k5vZl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 16px 10px #7e818c1f;
  position: fixed;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 1000;
}

.CustomHeader_notificationBtn__O547G {
  width: 40px;
  height: 40px;
  box-shadow: 0px 0px 16px 0px #7e818c1f;
  border: 1px solid #e2e2e2;
  background-color: white;
  border-radius: 5px;
  transition: background-color 300ms;
}

.CustomHeader_notificationBtn__O547G:hover {
  background-color: #e2e2e2;
  cursor: pointer;
}

.CustomHeader_backToHome__O\\+lXK {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.CustomHeader_backToHome__O\\+lXK:hover {
  cursor: pointer;
}
.CustomHeader_kalendarNav__dI\\+Xo {
  box-shadow: none;
}
.CustomHeader_h2Calendar__DdUzL {
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: 20px;
  font-weight: 600;
  font-family: Inter;
  color: #7e818c;
}

.CustomHeader_h1__aFVZh {
  margin-block-start: 10px;
  margin-block-end: 0px;
  font-size: 28px;
  font-weight: 600;
  font-family: Inter;
  color: #4d4d4d;
}
.CustomHeader_logo__44gxh {
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
}

.CustomHeader_userRow__YX5cN {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
}

.CustomHeader_notificationBtn__O547G {
  width: 40px;
  height: 40px;
  box-shadow: 0px 0px 16px 0px #7e818c1f;
  border: 1px solid #e2e2e2;
  background-color: white;
  border-radius: 5px;
  transition: background-color 300ms;
}

.CustomHeader_notificationBtn__O547G:hover {
  background-color: #e2e2e2;
  cursor: pointer;
}
.CustomHeader_pill__NnQwn {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 31px;
  background-color: #cb2d2d;
  font-size: 10px;
  line-height: 12px;
  text-align: left;
  color: #ffffff;
  position: absolute;
  top: -4px;
  right: -1.5px;
}

.CustomHeader_notificationBtn__O547G {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  box-shadow: 3px 4px 16px 0px #7e818c1f;
  border: 1px solid #e2e2e2;
  background-color: white;
  border-radius: 5px;
  transition: background-color 300ms;
}
.CustomHeader_notificationBtn__O547G:hover {
  background-color: #e2e2e2;
  cursor: pointer;
}

.CustomHeader_bell__HReFC {
  width: 24px;
  height: 24px;
}
.CustomHeader_bellColumn__iFMsu {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  position: relative;
}

@media screen and (max-width: 987px) {
  .CustomHeader_h2Calendar__DdUzL {
    font-size: 16px;
  }
  .CustomHeader_h1__aFVZh {
    font-size: 18px;
  }
  .CustomHeader_logo__44gxh {
    padding-left: 0px;
    align-items: center;
    display: flex;
  }
}

@media screen and (max-width: 424px) {
  .CustomHeader_nav__k5vZl {
    padding: 30px 20px;
  }
  .CustomHeader_logoImg__UocMr {
    height: 40px;
    width: auto;
  }
}
@media screen and (min-width: 425px) and (max-width: 574px) {
  .CustomHeader_nav__k5vZl {
    padding: 30px 20px;
  }
  .CustomHeader_logoImg__UocMr {
    height: 50px;
    width: auto;
  }
}
@media screen and (min-width: 575px) and (max-width: 679px) {
  .CustomHeader_nav__k5vZl {
    padding: 30px 30px;
  }
  .CustomHeader_logoImg__UocMr {
    height: 60px;
    width: auto;
  }
}
@media screen and (min-width: 680px) and (max-width: 767px) {
  .CustomHeader_nav__k5vZl {
    padding: 30px 50px;
  }
  .CustomHeader_logoImg__UocMr {
    height: 60px;
    width: auto;
  }
}
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .CustomHeader_nav__k5vZl {
    padding: 30px 50px;
  }
  .CustomHeader_logoImg__UocMr {
    height: 80px;
    width: auto;
  }
}
@media screen and (min-width: 1440px) {
  .CustomHeader_nav__k5vZl {
    padding: 50px 60px;
  }
  .CustomHeader_logoImg__UocMr {
    height: 100px;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomHeader/CustomHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,WAAW;EACb;AACF","sourcesContent":[".nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0px 0px 16px 10px #7e818c1f;\n  position: fixed;\n  width: 100%;\n  background-color: #fff;\n  box-sizing: border-box;\n  z-index: 1000;\n}\n\n.notificationBtn {\n  width: 40px;\n  height: 40px;\n  box-shadow: 0px 0px 16px 0px #7e818c1f;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  border-radius: 5px;\n  transition: background-color 300ms;\n}\n\n.notificationBtn:hover {\n  background-color: #e2e2e2;\n  cursor: pointer;\n}\n\n.backToHome {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.backToHome:hover {\n  cursor: pointer;\n}\n.kalendarNav {\n  box-shadow: none;\n}\n.h2Calendar {\n  margin-block-start: 0;\n  margin-block-end: 0;\n  font-size: 20px;\n  font-weight: 600;\n  font-family: Inter;\n  color: #7e818c;\n}\n\n.h1 {\n  margin-block-start: 10px;\n  margin-block-end: 0px;\n  font-size: 28px;\n  font-weight: 600;\n  font-family: Inter;\n  color: #4d4d4d;\n}\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n}\n\n.userRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 48px;\n}\n\n.notificationBtn {\n  width: 40px;\n  height: 40px;\n  box-shadow: 0px 0px 16px 0px #7e818c1f;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  border-radius: 5px;\n  transition: background-color 300ms;\n}\n\n.notificationBtn:hover {\n  background-color: #e2e2e2;\n  cursor: pointer;\n}\n.pill {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 31px;\n  background-color: #cb2d2d;\n  font-size: 10px;\n  line-height: 12px;\n  text-align: left;\n  color: #ffffff;\n  position: absolute;\n  top: -4px;\n  right: -1.5px;\n}\n\n.notificationBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  box-shadow: 3px 4px 16px 0px #7e818c1f;\n  border: 1px solid #e2e2e2;\n  background-color: white;\n  border-radius: 5px;\n  transition: background-color 300ms;\n}\n.notificationBtn:hover {\n  background-color: #e2e2e2;\n  cursor: pointer;\n}\n\n.bell {\n  width: 24px;\n  height: 24px;\n}\n.bellColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-start;\n  position: relative;\n}\n\n@media screen and (max-width: 987px) {\n  .h2Calendar {\n    font-size: 16px;\n  }\n  .h1 {\n    font-size: 18px;\n  }\n  .logo {\n    padding-left: 0px;\n    align-items: center;\n    display: flex;\n  }\n}\n\n@media screen and (max-width: 424px) {\n  .nav {\n    padding: 30px 20px;\n  }\n  .logoImg {\n    height: 40px;\n    width: auto;\n  }\n}\n@media screen and (min-width: 425px) and (max-width: 574px) {\n  .nav {\n    padding: 30px 20px;\n  }\n  .logoImg {\n    height: 50px;\n    width: auto;\n  }\n}\n@media screen and (min-width: 575px) and (max-width: 679px) {\n  .nav {\n    padding: 30px 30px;\n  }\n  .logoImg {\n    height: 60px;\n    width: auto;\n  }\n}\n@media screen and (min-width: 680px) and (max-width: 767px) {\n  .nav {\n    padding: 30px 50px;\n  }\n  .logoImg {\n    height: 60px;\n    width: auto;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 1439px) {\n  .nav {\n    padding: 30px 50px;\n  }\n  .logoImg {\n    height: 80px;\n    width: auto;\n  }\n}\n@media screen and (min-width: 1440px) {\n  .nav {\n    padding: 50px 60px;\n  }\n  .logoImg {\n    height: 100px;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `CustomHeader_nav__k5vZl`,
	"notificationBtn": `CustomHeader_notificationBtn__O547G`,
	"backToHome": `CustomHeader_backToHome__O+lXK`,
	"kalendarNav": `CustomHeader_kalendarNav__dI+Xo`,
	"h2Calendar": `CustomHeader_h2Calendar__DdUzL`,
	"h1": `CustomHeader_h1__aFVZh`,
	"logo": `CustomHeader_logo__44gxh`,
	"userRow": `CustomHeader_userRow__YX5cN`,
	"pill": `CustomHeader_pill__NnQwn`,
	"bell": `CustomHeader_bell__HReFC`,
	"bellColumn": `CustomHeader_bellColumn__iFMsu`,
	"logoImg": `CustomHeader_logoImg__UocMr`
};
export default ___CSS_LOADER_EXPORT___;
